import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { EventNotification } from "../../domain/EventNotification";
import { Controller } from "react-hook-form";
import { SectionProps } from "./SectionProps";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { fieldLabels } from "./fieldLabels";

export const AffectedQualifications: React.FC<
  SectionProps<EventNotification>
> = ({
  control,
  disabled,
}) => {

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body1">
          You should add specific qualifications and units through Linked Records once you have saved the event notification.
        </Typography>
        <Typography variant="body1">
          If you want to provide more information about qualifications and units, please use the field below.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="informationOnQualsUnitsAffected"
          as={
            <TextField
              variant="outlined"
              label={fieldLabels["informationOnQualsUnitsAffected"]}
              fullWidth
              readOnly={disabled}
              multiline
              data-test="qual-more-information"
            />
          }
        />
      </Grid>
    </Grid>
  );
};
